import React from 'react'
import { useTranslation } from 'react-i18next'
import { ExclamationIcon } from '@heroicons/react/outline'

// Full-width banner shown at the top of the GenerateShipment page when an order
// is under packing audit (§8.1). Two variants:
//  - default: red gradient + alert-triangle icon.
//  - critical (selection_reason === 'critical_client'): orange/red gradient with a
//    pulsing animation and a fire emoji, to demand extra attention.
export const PackingAuditBanner = ({ isCritical = false }) => {
  const { t } = useTranslation()

  // NOTE: this Tailwind v2 config only registers `amber` and `emerald` from the
  // extended palette (tailwind.config.js) — `orange` is NOT available, so
  // `from-orange-*` compiles to nothing. `amber-500` (#f59e0b) is the in-palette
  // orange used for the critical (pulsing) gradient.
  const containerClasses = isCritical
    ? 'bg-gradient-to-r from-amber-500 to-red-600 animate-pulse'
    : 'bg-gradient-to-r from-red-600 to-red-700'

  return (
    <div
      role="alert"
      className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg shadow text-white font-semibold ${containerClasses}`}
    >
      {isCritical ? (
        <span className="text-2xl leading-none" aria-hidden="true">🔥</span>
      ) : (
        <ExclamationIcon className="h-6 w-6 flex-shrink-0" aria-hidden="true" />
      )}
      <span className={isCritical ? 'text-lg' : 'text-base'}>
        {t(isCritical ? 'packing_audit.banner.critical' : 'packing_audit.banner.default')}
      </span>
    </div>
  )
}
